export default __webpack_public_path__ + "static/81499-1a31236f161128fbc3bc0ce73fa0a27e.jpg";